import { keymirror } from 'utils/keymirror'

export const CHECKLIST_DIALOG_ACTION_TYPES = keymirror({
  OPEN_CHECKLIST_DIALOG: null,
  CLOSE_CHECKLIST_DIALOG: null,
})

export const showChecklistDialog = () => ({
  type: CHECKLIST_DIALOG_ACTION_TYPES.OPEN_CHECKLIST_DIALOG,
})

export const closeChecklistDialog = () => ({
  type: CHECKLIST_DIALOG_ACTION_TYPES.CLOSE_CHECKLIST_DIALOG,
})
